import { render, staticRenderFns } from "./orderPdLists.vue?vue&type=template&id=d8d8fbc4&scoped=true&"
import script from "./orderPdLists.vue?vue&type=script&lang=js&"
export * from "./orderPdLists.vue?vue&type=script&lang=js&"
import style0 from "./orderPdLists.vue?vue&type=style&index=0&id=d8d8fbc4&scoped=true&lang=css&"
import style1 from "./orderPdLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d8fbc4",
  null
  
)

export default component.exports